import CompanyCard from '@/components/CompanyCard'
import UserCard from '@/components/UserCard'
import Vue from 'vue'

const ListItemDateTime = () => import('@/components/Engine/ListItemDateTime')
const AccountingListActions = () => import(/* webpackChunkName: "misc" */ '@/components/Accounting/ListActions')

const pendingAccountingNotesModel = vm => ({
  title: vm.$gettext('Pending Accounting Notes'),
  endpoint: 'accounting-notes',
  countrize: 'country_iso_code',
  noIdLink: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'type',
      label: vm.$gettext('Type'),
      sortable: true,
      formatter: (value, key, item) => {
        const color = value === 'credit' ? 'danger' : 'success'
        let html = ''
        html += '<span class="text-' + color + '">' + value + '</span>'
        if (item.is_outsourcing) {
          html += '<br><span class="badge badge-danger">3P</span>'
        }
        return html
      }
    },
    {
      key: 'amount',
      label: vm.$gettext('Amount'),
      formatter: (value, key, item) => {
        return value + ' ' + item.currency
      }
    },
    {
      key: 'reference',
      label: vm.$gettext('Reference')
    },
    {
      key: 'account',
      label: vm.$gettext('Account'),
      formatter: (value, key, item) => {
        if (value.model_type.indexOf('User') !== -1) {
          return new Vue({
            ...UserCard,
            parent: this,
            propsData: {
              user: value.owner,
              profilePicture: false,
              withTitles: false,
              withMap: false
            }
          }).$mount().$el.outerHTML
        } else {
          return new Vue({
            ...CompanyCard,
            parent: this,
            propsData: {
              company: value.owner,
              profilePicture: false,
              withTitles: false,
              withContact: false
            }
          }).$mount().$el.outerHTML
        }
      }
    },
    {
      key: 'applied_by',
      label: vm.$gettext('Applied By'),
      sortable: true,
      formatter: (value, key, item) => {
        return new Vue({
          ...UserCard,
          parent: this,
          propsData: {
            user: value,
            profilePicture: false,
            withTitles: false,
            withMap: false
          }
        }).$mount().$el.outerHTML
      }
    },
    {
      key: 'imputation_date',
      label: vm.$gettext('Imputation Date'),
      sortable: true,
      editable: false,
      required: true,
      component: value => ({
        is: ListItemDateTime,
        props: { value }
      })
    },
    {
      key: 'actions',
      label: vm.$gettext('Actions'),
      hidden: true,
      component: (value, key, item, row) => ({
        is: AccountingListActions,
        props: { row },
        on: {
          refresh: () => vm.$root.$emit('bv::refresh::table', 'apiListTable')
        }
      })
    }
  ],
  includes: ['account.owner', 'applied_by', 'shipping'],
  filters: ['id', 'status', 'is_outsourcing']
})

export default pendingAccountingNotesModel
